import { BlockToComponentMap } from 'app/features/shared/blocks'
import { BrandFeaturedOfferBlockType, BrandFeaturedOfferComponent, canRenderFeaturedOfferBlock } from './brand-featured-offer-block'
import { BrandOfferCollectionBlockType, BrandOfferCollectionComponent, canRenderBrandOfferCollectionBlock } from './brand-offer-collection-block'
import { BrandOfferListBlockType, canRenderBrandOfferListBlock } from './brand-offer-list-block'

export const getBrandBlockMappings = (): BlockToComponentMap => ({
  [BrandFeaturedOfferBlockType]: { Component: BrandFeaturedOfferComponent, canRender: canRenderFeaturedOfferBlock },
  [BrandOfferCollectionBlockType]: { Component: BrandOfferCollectionComponent, canRender: canRenderBrandOfferCollectionBlock },
  [BrandOfferListBlockType]: { Component: BrandOfferCollectionComponent, canRender: canRenderBrandOfferListBlock },
})
